
import _ from './Manager'
import app from './App/App'
//import StaticHtmlPage from './pages/StaticHtml'
import BowlingPage from './pages/Bowling'
import BookingPage from './pages/Booking'
import WeekBookingPage from './pages/WeekBooking'
import LoginPage from './pages/Login'
import './style.scss'

_.addPageClass( 'Bowling', BowlingPage )
_.addPageClass( 'Booking', BookingPage )
_.addPageClass( 'WeekBooking', WeekBookingPage )
_.addPageClass( 'Login', LoginPage )

window._= function(){ return _.defaultRoute(...arguments) }
window._.open= _.open.bind(_)
window._.switchTo= _.switchTo.bind(_)
window._.returns= _.returns.bind(_)
window._.request= _.request.bind(_)
window._.app= app
window._.manager= _

app.start()